import React from "react";
import { Navigate, Outlet } from "react-router";
import authService from "../../services/authService";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const user = authService.getCurrentUser();

  return user ? <Outlet {...rest} /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
